import React from 'react'
import { useSelector } from 'react-redux'

import { TopBarLeft } from 'screens/Topbar/TopBarLeft'

import SidePanelResizable from 'components/Layout/AppLayout/Panel/resizable'

import useNavigation from './hooks/useNavigation'
import { OnboardingStepPopover } from 'screens/OnboardingPopover'
import { getColorMode, COLORMODES } from 'data/userPreferences/selectors'
import classNames from 'classnames'
import Onboarding from './Onboarding'

import { SidebarEntry } from './Items/Entry'

import ContextualNewNoteButton from './ContextualNewNoteButton'
import {
  isOnboardingOnInviteStep,
  isOnboardingOnChannelsStep,
} from 'screens/OnboardingPopover/utils'
import { isCurrentUserTheOwner } from 'data/users/selectors'

export type NewSidebarProps = {
  hidden?: boolean
}

export const NewSidebar = ({ hidden }: NewSidebarProps) => {
  const { bottomEntries, scrollableEntries } = useNavigation()

  const isOnboardingActive = useSelector(
    state =>
      isCurrentUserTheOwner(state) &&
      (isOnboardingOnChannelsStep(state) || isOnboardingOnInviteStep(state))
  )

  const colorMode = useSelector(getColorMode)

  let sideBarContent
  if (isOnboardingActive) {
    sideBarContent = <Onboarding />
  } else {
    sideBarContent = (
      <>
        <ContextualNewNoteButton className="flexbox-no-grow flexbox-no-shrink margin-bottom-medium" />

        <div
          className="flexbox-grow scroll-y flexbox flexbox-column padding-horizontal-normal"
          style={{ margin: '0 -12px' }}
        >
          <OnboardingStepPopover
            step="channels"
            position="right"
            popoverStyle={{ marginTop: 4, marginLeft: 20 }}
            align="start"
          >
            {/* We need an empty otherwise popover won't render */}
            <div />
          </OnboardingStepPopover>
          {scrollableEntries.map((entryProps: any) => (
            <SidebarEntry key={entryProps.key} {...entryProps} />
          ))}

          <div className="flexbox-grow margin-top-medium" />
          {bottomEntries.map((entryProps: any) => (
            <SidebarEntry key={entryProps.key} {...entryProps} />
          ))}
          <div className="margin-bottom-small" />
        </div>
      </>
    )
  }

  return (
    <SidePanelResizable
      className={classNames(
        {
          'border-shade-50': colorMode === COLORMODES.DARK,
          'color-mode-elevated border-shade-100-dark-mode':
            colorMode !== COLORMODES.DARK,
          'display-none': hidden,
        },
        'dark-mode width-full height-full-page flexbox border-right-medium background-shade-100 flexbox-column',
        'padding-horizontal-normal'
      )}
      style={{ gridArea: 'sidebar' }}
    >
      <TopBarLeft className="flexbox-no-shrink border-bottom-none" />
      {sideBarContent}
    </SidePanelResizable>
  )
}
